import { getAccountValidationForBackgroundCheckSchema } from '@/backend/features/background-check/shared/getAccountValidationForBackgroundCheckSchema';
import { BackgroundCheckType } from '@/backend/features/background-check/types';
import { useAccountDetailsFields } from '@/ui/features/background-check/components/background-check-modal/hooks/useAccountDetailsFields';
import { getErrorFieldsLabels } from '@/ui/features/background-check/components/background-check-modal/hooks/utils';
import { AccountData } from '@juvare/contact-management/backend/features/accounts/shared';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const useAccountValidator = (account: AccountData, type: BackgroundCheckType) => {
    const { t } = useTranslation('rms');
    const accountDetailsFields = useAccountDetailsFields({ type });
    const requiredInfoText = t('backgroundCheck.labels.requiredInfo');
    const invalidAddressLine1 = t('backgroundCheck.messages.invalidAddressLine1');
    const invalidPostalCode = t('backgroundCheck.messages.invalidPostalCode');

    const validationSchema = React.useMemo(
        () =>
            getAccountValidationForBackgroundCheckSchema({
                type,
                requiredInfoText,
                invalidAddressLine1,
                invalidPostalCode,
            }),
        [type, invalidAddressLine1, invalidPostalCode, requiredInfoText],
    );

    const validationResults = validationSchema.safeParse(account);
    const validationErrors = validationResults.error?.format();
    const errorFieldsLabels = getErrorFieldsLabels({ account, accountDetailsFields, validationErrors, t });

    return { validationResults, validationErrors, errorFieldsLabels };
};
